var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    d: "M1026.214,34.053c-1.8-1.563-3.461-3.767-3.461-9.272a5.752,5.752,0,1,0-11.5,0c0,5.51-1.663,7.712-3.462,9.274A2.294,2.294,0,0,0,1007,35.78a.656.656,0,0,0,.654.658h6.21a3.2,3.2,0,0,0,6.272,0h6.21a.656.656,0,0,0,.654-.658A2.281,2.281,0,0,0,1026.214,34.053ZM1017,37.685a1.9,1.9,0,0,1-1.778-1.247h3.556A1.9,1.9,0,0,1,1017,37.685Zm-8.434-2.563a.958.958,0,0,1,.076-.074c2.743-2.381,3.913-5.451,3.913-10.267a4.444,4.444,0,1,1,8.888,0c0,4.812,1.171,7.882,3.915,10.268a.975.975,0,0,1,.076.073Z",
    transform: "translate(-1007 -19)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification_bell.f6e7b6c7aefe52f77960c47d8f9a4192.svg";
export { ForwardRef as ReactComponent };